




























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  SettingsCardInfo,
  SettingsCardSections,
  SettingsGetters,
  SettingsMutations,
  SettingsTitle
} from "@/components/settings/types";
import { Getter, Mutation } from "vuex-class";
import { Namespace } from "@/store/types";
import SpatialNavigation from "spatial-navigation-js";
import { keyCodeFinder } from "@/services/keyCodeService/keyCodeService";
import { KeySet } from "@/services/keyCodeService/keyCode.types";
import { scrollToPage } from "@/helpers/utils";

@Component({})
export default class SettingsCard extends Vue {
  @Prop() readonly settingsCardInfo!: SettingsCardInfo;
  @Prop() readonly cardInfoIndex!: number;
  @Prop() readonly cardSection!: SettingsCardSections;

  @Mutation(SettingsMutations.setPinOverlay, { namespace: Namespace.Settings })
  setPinOverlay!: (overlayStatus: boolean) => void;

  @Mutation(SettingsMutations.setOpenRightSideMenu, {
    namespace: Namespace.Settings
  })
  setOpenRightSideMenu!: (overlayStatus: boolean) => void;

  @Mutation(SettingsMutations.setActiveCardIndex, {
    namespace: Namespace.Settings
  })
  setActiveCardIndex!: (cardIndex?: number) => void;

  @Mutation(SettingsMutations.setActiveCardSection, {
    namespace: Namespace.Settings
  })
  setActiveCardSection!: (cardSection?: SettingsCardSections) => void;

  @Mutation(SettingsMutations.setRightSideMenuTitle, {
    namespace: Namespace.Settings
  })
  setRightSideMenuTitle!: (rightSideMenuTitle?: SettingsTitle) => void;

  @Getter(SettingsGetters.getEncodedPin, { namespace: Namespace.Settings })
  getEncodedPin!: string;

  @Getter(SettingsGetters.getPinOverlay, { namespace: Namespace.Settings })
  getPinOverlay!: boolean;

  @Getter(SettingsGetters.getActiveCardIndex, { namespace: Namespace.Settings })
  getActiveCardIndex?: number;

  @Getter(SettingsGetters.getActiveCardSection, {
    namespace: Namespace.Settings
  })
  getActiveCardSection?: SettingsCardSections;

  @Getter(SettingsGetters.getOpenRightSideMenu, {
    namespace: Namespace.Settings
  })
  getOpenRightSideMenu!: boolean;

  scrollFuncRef = scrollToPage;

  mounted(): void {
    this.refocusCard();
  }

  handleCardActions(event: KeyboardEvent): void {
    const targetId = event.target instanceof Element ? event.target.id : "";

    switch (keyCodeFinder(event.keyCode)) {
      case KeySet.KEY_LEFT:
        if (
          targetId === SettingsCardSections.Personal + "0" ||
          targetId === SettingsCardSections.Other + "0"
        ) {
          SpatialNavigation.focus("#" + this.$route.name);
        }
        break;
      case KeySet.KEY_ENTER:
        this.setActiveCardIndex(this.cardInfoIndex);
        this.setActiveCardSection(this.cardSection);
        this.openPage();
        break;
    }
  }

  //setting proper section and card id for focusing after closing overlays or returning form a sub page
  openPage(): void {
    if (
      this.getActiveCardIndex === this.cardInfoIndex &&
      this.getActiveCardSection === this.cardSection
    ) {
      if (this.settingsCardInfo.requiresPin && this.getEncodedPin === "") {
        this.setPinOverlay(true);
        return;
      }
      if (this.settingsCardInfo.opensRightSideMenu) {
        this.setOpenRightSideMenu(true);
        this.setRightSideMenuTitle({
          heading: this.settingsCardInfo.rightSideMenuTitle?.heading,
          subHeading: this.settingsCardInfo.rightSideMenuTitle?.subHeading
        });
        return;
      }
      if (this.settingsCardInfo.attachedRoute) {
        this.$router.push({ name: this.settingsCardInfo.attachedRoute });
      }
    }
  }

  refocusCard(): void {
    if (
      this.getActiveCardIndex === this.cardInfoIndex &&
      this.getActiveCardSection === this.cardSection
    ) {
      SpatialNavigation.focus("#" + this.cardSection + this.cardInfoIndex);
      this.setActiveCardIndex();
      this.setActiveCardSection();
      this.setRightSideMenuTitle();
    }
  }

  @Watch("getEncodedPin")
  handlePinValidation(newVal: string): void {
    if (newVal !== "") {
      this.openPage();
    }
  }

  @Watch("getPinOverlay")
  @Watch("getOpenRightSideMenu")
  handlePinOverlayClose(newVal: boolean): void {
    if (!newVal) {
      this.refocusCard();
    }
  }
}
